import $ from "jquery";

export const UserActivity = function () {
	let userActivityTimer;
	let sessionStartTime = Date.now();
	let isTracking = false;
	let lastActivityTime = Date.now();
	let activityThreshold = 60000; // 1 minute of inactivity

	/**
	 * Initialize user activity tracking
	 */
	function initUserActivityTracking() {
		// Check if user is a subscriber (you can add this check)
		if (window.CFG.currentUserId != "0") {
			isTracking = true;
		}

		if (isTracking) {
			// Reset timer on user activity
			document.addEventListener("mousemove", resetActivityTimer);
			document.addEventListener("keypress", resetActivityTimer);
			document.addEventListener("click", resetActivityTimer);
			document.addEventListener("scroll", resetActivityTimer);

			// Check for activity every 30 seconds instead of tracking
			userActivityTimer = setInterval(checkUserActivity, 30000);

			// Send heartbeat every 2 minutes to detect abandoned sessions
			setInterval(sendHeartbeat, 120000);

			// Track on page unload with reliable delivery
			window.addEventListener("beforeunload", function () {
				// Send final activity before page closes
				const timeSpent = Math.floor((Date.now() - sessionStartTime) / 1000);

				if (timeSpent > 0 && window.CFG.currentUserId != "0") {
					// Use sendBeacon for reliable delivery during page unload
					if (navigator.sendBeacon) {
						const data = new FormData();
						data.append("action", "update_user_activity");
						data.append("time_spent", timeSpent);
						data.append("nonce", window.CFG?.nonce || "");
						data.append("is_final", "1");

						navigator.sendBeacon(window.CFG.ajaxUrl, data);
					} else {
						// Fallback to synchronous AJAX (less reliable)
						$.ajax({
							url: window.CFG.ajaxUrl,
							type: "POST",
							async: false,
							data: {
								action: "update_user_activity",
								time_spent: timeSpent,
								nonce: window.CFG?.nonce || "",
								is_final: "1",
							},
						});
					}
				}
			});

			// Handle page visibility changes (tab switching, browser minimization)
			document.addEventListener("visibilitychange", function () {
				if (document.hidden) {
					// User switched tabs or minimized browser
				} else {
					// User returned to page
					resetActivityTimer();
				}
			});
		}
	}

	/**
	 * Reset activity timer
	 */
	function resetActivityTimer() {
		sessionStartTime = Date.now();
		lastActivityTime = Date.now();
	}

	/**
	 * Check if user has been active recently before tracking
	 */
	function checkUserActivity() {
		const timeSinceLastActivity = Date.now() - lastActivityTime;

		// Only track if user has been active recently
		if (timeSinceLastActivity < activityThreshold) {
			trackUserActivity();
		}
	}

	/**
	 * Send heartbeat to detect abandoned sessions
	 */
	function sendHeartbeat() {
		if (window.CFG.currentUserId != "0") {
			$.post(window.CFG.ajaxUrl, {
				action: "user_heartbeat",
				nonce: window.CFG?.nonce || "",
			});
		}
	}

	/**
	 * Track subscriber activity and send to backend
	 */
	function trackUserActivity() {
		const timeSpent = Math.floor((Date.now() - sessionStartTime) / 1000);

		// Only send if there's meaningful activity
		if (timeSpent > 0) {
			// Send to backend via AJAX
			if (window.CFG.currentUserId != "0") {
				$.post(window.CFG.ajaxUrl, {
					action: "update_user_activity",
					time_spent: timeSpent,
					nonce: window.CFG?.nonce || "",
				})
					.done(function (response) {
						if (response.success) {
							// Reset timer after successful tracking
							sessionStartTime = Date.now();
						}
					})
					.fail(function () {
						// Handle AJAX failure silently
					});
			}
		}
	}

	/**
	 * Start tracking manually (can be called from other components)
	 */
	function startTracking() {
		if (!isTracking) {
			isTracking = true;
			initUserActivityTracking();
		}
	}

	/**
	 * Stop tracking manually
	 */
	function stopTracking() {
		if (isTracking) {
			isTracking = false;
			if (userActivityTimer) {
				clearInterval(userActivityTimer);
			}

			// Remove event listeners
			document.removeEventListener("mousemove", resetActivityTimer);
			document.removeEventListener("keypress", resetActivityTimer);
			document.removeEventListener("click", resetActivityTimer);
			document.removeEventListener("scroll", resetActivityTimer);
		}
	}

	/**
	 * Get current session time
	 */
	function getCurrentSessionTime() {
		return Math.floor((Date.now() - sessionStartTime) / 1000);
	}

	/**
	 * Check if tracking is active
	 */
	function isTrackingActive() {
		return isTracking;
	}

	// Initialize when DOM is ready
	$(document).ready(function () {
		initUserActivityTracking();
	});

	// Make functions globally available
	return {
		init: initUserActivityTracking,
		start: startTracking,
		stop: stopTracking,
		getSessionTime: getCurrentSessionTime,
		isActive: isTrackingActive,
	};
};
